import { I } from '@angular/cdk/keycodes';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TranslateService {

  constructor(private httpClient: HttpClient) { }

  private Resources: any = null;
  private cache:{Slug:string,Resources:any }= null;

  public async getResources(slug:string) {
    if(this.cache && this.cache.Slug.toLowerCase() == slug.toLowerCase()){
      return of(this.Resources);
    }else{
      return this.httpClient.post(`/Localization/GetSlugLocalization`, { slug: slug }).pipe(map(res => {

        if (res) {
          this.Resources = res

          this.cache={
            Resources:res,
            Slug:slug
          }
        }
      }))
    
    }
      
    
    
  }
  public async GetResourcesP(slug:string,key,group,componentName):Promise<any> {


    if(this.cache && this.cache.Slug.toLowerCase() == slug.toLowerCase()){
       return of(this.TranslateKey(key,group,componentName))
        .toPromise();
    }else{
      return this.httpClient.post(`/Localization/GetSlugLocalization`, { slug: slug }).pipe(map(res => {

        if (res) {
          this.Resources = res

          this.cache={
            Resources:res,
            Slug:slug
          }
         return of(this.TranslateKey(key,group,componentName)).toPromise();
        }
      })).toPromise();
    
    }
     ;
  }


   
  public TranslateKey(key,group,component){
    if(this.Resources){
    if(group && key in  this.Resources[group]){
      return this.Resources[group][key];
    }
    else if(key in this.Resources["SlugResources"]){
      return this.Resources["SlugResources"][key];
    }
    else if(key in this.Resources["SharedResources"]){
      return this.Resources["SharedResources"][key]
    }else{
      this.scanKey(key,component,group).subscribe();
      return key;
    }
  }
      return '';
  }

  private scanKey(key,Component,Group){
    return this.httpClient.post(`/Localization/ScanResource`,{key,Component, Group});
  }

}
